import React, { useEffect, useState } from 'react'
import { Link, useLocation, useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { Button } from 'components'
import Skeleton from 'react-loading-skeleton'

import { AddressActionModal, AddressCard } from '../../components'

import { Add } from 'iconsax-react'
import { EmptyAdressSvg } from 'assets/images'

import styles from './styles.module.css'
import useColors from 'utils/Colors'

import { useQuery } from '@tanstack/react-query'
import { GetAdressList, UpdateProfile } from 'services/account'

import { actions as commonActions } from 'store/commonRedux/actions'

import { _queryToUrlParams } from 'utils/_helpers'

const AddressList = ({ onFinish }) => {
  const dispatch = useDispatch()

  const tempAddress = useSelector(({ common }) => common.tempAddress)

  const [selectedAddress, setSelectedAddress] = useState()
  const [actionModal, setActionModal] = useState({
    show: false,
    data: undefined,
    refetch: false,
  })

  const [searchParams, setSearchParams] = useSearchParams()

  const location = useLocation()
  const Colors = useColors()

  const { data, refetch } = useQuery({
    queryKey: ['[List] Address'],
    queryFn: () => GetAdressList().then((result) => result.results),
  })

  const renderList = () => {
    const flag = data ? (data.length > 0 ? 'loaded' : 'empty') : 'loading'

    switch (flag) {
      case 'loaded':
        return data.map((item) => (
          <AddressCard
            onAction={(state) => setActionModal(state)}
            onSelect={() => setSelectedAddress(item)}
            selected={item.id == selectedAddress?.id}
            item={item}
          />
        ))

      case 'loading':
        return [1, 2, 3].map(() => (
          <div style={{ marginBottom: 16 }}>
            <Skeleton height={93} />
          </div>
        ))

      case 'empty':
        return (
          <div
            className="d-flex flex-column align-items-center"
            style={{ marginTop: 72 }}
          >
            <span className={styles.empty_label}>شما هیچ آدرسی ندارید.</span>
            <img src={EmptyAdressSvg} />
          </div>
        )

      default:
        break
    }
  }

  useEffect(() => {
    if (actionModal.refetch) {
      refetch()
    }
  }, [actionModal])

  useEffect(() => {
    if (tempAddress && tempAddress.type == 'ADDRESS_OBJECT' && data) {
      setSelectedAddress(data.find((address) => address.id == tempAddress.id))
    }
  }, [data, tempAddress])

  return (
    <div className={styles.container}>
      <h4 className={styles.title}>محل تحویل سفارشتان را مشخص کنید</h4>
      {renderList()}
      <Link
        to={`/profile/address/create?returnUrl=${
          location.pathname
        }&updateAddress=true${_queryToUrlParams(Object.fromEntries(searchParams))}`}
      >
        <Button width={'100%'} height={'44px'} type={'primary'} ghost={true}>
          <Add style={{ marginLeft: 10 }} size={24} color={Colors.Primary[3]} />
          افزودن آدرس
        </Button>
      </Link>
      {selectedAddress && (
        <Button
          width={'100%'}
          height={'44px'}
          type={'primary'}
          style={{ marginTop: 12 }}
          onClick={() => {
            dispatch(
              commonActions.setTempAddress({
                ...selectedAddress,
                type: 'ADDRESS_OBJECT',
              }),
            )
            onFinish()
          }}
        >
          تایید
        </Button>
      )}
      {/* Address Action Modal */}
      <AddressActionModal
        isOpen={actionModal.show}
        setIsOpen={(state) => setActionModal(state)}
        data={actionModal.data}
      />
      {/* X Address Action Modal X*/}
    </div>
  )
}

export default AddressList
